module.exports = __webpack_public_path__ + "static/media/RS.114d5853.wav";